import type { ReactNode } from "react";

type ContainerProps = {
	children: ReactNode;
	className?: string;
};

/** Caixa centrada com a largura máxima do site. */
export function Container({ children, className }: ContainerProps) {
	return (
		<div className={className ? `container ${className}` : "container"}>
			{children}
		</div>
	);
}
